import React from 'react'
import Navbar from '../Navbar/Navbar'
import './contact.css';
import { IoLogoWhatsapp } from "react-icons/io";
import Footer from '../footer/Footer';

function Contact() {
    return (
        <>
            <Navbar />


            <div className='contactmain'>
                <div className='contactinner'>
                    <h2>Contact Us</h2>
                </div>
            </div>

            <div className='contactupper'>
                <div className='contactleft'>
                    <div className='contactadd'>
                        <IoLogoWhatsapp className='contacticon' />
                        <div><p>G2,Kinetic canvas, Near Vastav Vadapav, Ram mandir road, Khar west, Mumbai 400052</p></div>
                    </div>
                    <div className='contactadd'>
                        <IoLogoWhatsapp className='contacticon' />
                        <div><p>G2,Kinetic canvas, Near Vastav Vadapav, Ram mandir road, Khar west, Mumbai 400052</p></div>
                    </div>
                    <div className='contactadd'>
                        <IoLogoWhatsapp className='contacticon' />
                        <div><p>G2,Kinetic canvas, Near Vastav Vadapav, Ram mandir road, Khar west, Mumbai 400052</p></div>
                    </div>
                </div>
                <div className='contactright'>
                    <iframe frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?q=nayak%27s%20tutorials&amp;t=m&amp;z=12&amp;output=embed&amp;iwloc=near" title="nayak's tutorials" aria-label="nayak's tutorials" width="460" height="380"></iframe>
                </div>
            </div>

            <Footer />
        </>
    )
}

export default Contact
